(function () {
    'use strict';

    run.parts.bsCustomFileInput = function() {
        $(document).ready(function () {
            bsCustomFileInput.init()
        })
    };
})();